import { render, staticRenderFns } from "./MultiCategoriesSelector.vue?vue&type=template&id=4f7ec8f8&"
import script from "./MultiCategoriesSelector.vue?vue&type=script&lang=ts&"
export * from "./MultiCategoriesSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports